import Cookie from 'js-cookie'

export function normalizeAuthHeader(token) {
  if (!token) {
    return ''
  }
  if (token.startsWith('Bearer ')) {
    return token
  }
  if ((token.match(/\./g) || []).length === 2) {
    return token
  }
  return `Bearer ${token}`
}

export function applyAuthSession(authData) {
  if (!authData?.accessToken) {
    return
  }
  Cookie.set('token', authData.accessToken)
  if (authData.username) {
    Cookie.set('username', authData.username)
  }
  if (authData.userId) {
    Cookie.set('userId', authData.userId)
  }
}

export function applyDistributionSession(token, profile = {}) {
  if (!token) {
    return
  }
  applyAuthSession({
    accessToken: token,
    username: profile.username,
    userId: profile.userId,
    realName: profile.realName,
    nickName: profile.nickName
  })
}

export function clearAuthSession() {
  Cookie.remove('token')
  Cookie.remove('username')
  Cookie.remove('userId')
}

export function getToken() {
  return Cookie.get('token')
}

/** 本地已有 token 且 userId 已写入，无需重复请求 /sso/me */
export function hasAuthSession() {
  return !!(getToken() && Cookie.get('userId'))
}
